<template>
  <div>
    <div class="see-banner">
      <div class="main-center container">
        <h1 class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.2s">How LightCourse works</h1>
        <em>?</em>
      </div>
    </div>
    <main class="see-container">
      <section class="main-0">
        <div class="main-center container">
          <div class="t">
            <h2>Worldwide access to Credit-bearing courses,<br>
              both online and on-campus
            </h2>
          </div>
          <div class="m1">
            <div class="main-title">
              <h2>1.&nbsp;&nbsp;&nbsp;7000+COLLEGE COURSES</h2>
              <p class="college">LightCourse provides worldwide access to credit-bearing college courses, both online and on-campus.</p>
            </div>

            <div class="mt">
              <p class="title-p">
                We partner with top-notch institutions around the world and offer 7000+ official college courses covering more than 300 different<br />
                majors and disciplines, including <span class="c1">mathematics, business, computer science, communications, art, social science, humanities</span>, and <br />
                <span class="c1">other fields.</span> Available courses include required courses for many majors, general education requirements, electives at various<br />
                levels, as well as more specialized offerings.
              </p>
            </div>
          </div>

        </div>
      </section>
      <section class="main-1-1">
        <div class="main-center container">
          <div class="title">
            <h3>What We Provide ?</h3>
            <p>Credit-bearing online courses</p>
            <span>For individual online courses, students can choose between live ("synchronous") or recorded ("asynchronous") courses as the mode of instruction. Along with the usual spring, summer, fall, and winter terms, there are also self-paced courses available, allowing students to choose the appropriate classes based on their own schedules.</span>
          </div>
          <div class="list">
            <div class="item">
              <h4>Synchronous/<br>Live</h4>
              <span>
						Students join live video conference classrooms during scheduled class hours.<br /><br />
						Professors teach face-to-face classes while also live-streaming to online students who attend virtually via the internet.
					</span>
            </div>
            <div class="item">
              <h4>Asynchronous/<br>Recorded</h4>
              <span>
						Professors pre-record lectures, and students watch the recordings before specific deadlines.  record lectures during synchronous/live classes, and students who are unable to attend the class live can instead view the recorded lecture later.
					</span>
            </div>
            <div class="item">
              <h4>Self-paced</h4>
              <span>Self-paced courses give students a great deal of flexibility, allowing them to register and start classes at any time. Students can have more freedom in terms of finishing their studies, as they may work at their own pace without worrying about regular deadlines.</span>
            </div>
          </div>
          <div class="title title-2">
            <h3>Who is this format best for?</h3>
          </div>
          <div class="list">
            <div class="item">
              <span>Students seeking to interact with their instructors and classmates, and students who want an online course that is most similar to a traditional in-person classroom experience.</span>
            </div>
            <div class="item">
              <span>Students whose schedules make it difficult to attend live classes at set times, and students who prefer to watch lectures repeatedly in order to understand more thoroughly.</span>
            </div>
            <div class="item">
              <span>Students whose schedules require them to keep maximum flexibility when taking classes, and students who want complete control over their learning schedule.</span>
            </div>
          </div>
          <div class="list list-last">
            <div class="item">
              <h4>Who is this format best for?</h4>
              <span>
						<em>Course level:</em>Undergraduate/Graduate<br />
						<em>Typical length:</em>Spiring,Fall:  8-14weeks  <br />
                        <em></em>Summer:3-12weeks<br />
                        <em></em>Winter:2.5-4weeks<br />
						<em>Credit hours:</em>3/4<br />
						<em>Quarter credit hours:</em>3/4*1.5
					</span>
            </div>
            <div class="item">
              <h4>Self-paced</h4>
              <span>Register at any time, and complete it according to your progress within the deadline.</span>
              <span>
						Credit hours are course-dependent, usually:<br />
						<em>Semester credit hours:</em>3/4<br />
						<em>Quarter credit hours:</em>3/4*1.5
					</span>
            </div>
          </div>
        </div>
      </section>
      <section class="main-1-2">
        <div class="main-center container">
          <div class="main-title">
            <h2>2.&nbsp;&nbsp;&nbsp;Credit-bearing study abroad programs</h2>
            <p class="study-programs">
              LightCourse collaborates with renowned institutions around the world to offer credit-bearing study
              abroad programs to students who want to broaden<br />
              their cultural horizons. Students can study <span class="c1">business, math, computer science, natural sciences, social sciences, humanities, and arts</span><br />
              in summer school programs provided by institutions
              in locations such as <span class="c1">San Francisco, London, Florence, Toronto, Seoul, Tokyo, Shanghai, and Beijing.</span>
            </p>
          </div>
          <div class="student-programs-swiper">
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-01.jpg"' alt="beijing"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-02.jpg"' alt="shanghai"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-03.jpg"' alt="florence"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-04.jpg"' alt="san francisco"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-05.jpg"' alt="london"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-06.jpg"' alt="tokyo"></div>
                <div class="swiper-slide"><img :src='this.$store.state.baseURL + "/new/images/study-programs-07.jpg"' alt="seoul"></div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
      </section>
      <section class="main-4">
        <div class="main-center container">
          <div class="main-title">
            <h2>3.&nbsp;&nbsp;&nbsp;How to Participate</h2>
          </div>
          <div class="participate-list">
            <div class="item">
              <span>Step1</span>
              <span>Check the transfer credit policy of your school</span>
            </div>
            <div class="item">
              <span>Step2</span>
              <span>Check if the selected course covers the one in your school</span>
            </div>
            <div class="item">
              <span>Step3</span>
              <span>Select a program/course</span>
            </div>
            <div class="item">
              <span>Step4</span>
              <span>Submit personal information for course registration</span>
            </div>
            <div class="item">
              <span>Step5</span>
              <span>Confirm your order and make a payment</span>
            </div>
            <div class="item">
              <span>Step6</span>
              <span>Receive course details upon registration</span>
            </div>
            <div class="item">
              <span>Step7</span>
              <span>Start taking classes</span>
            </div>
            <div class="item">
              <span>Step8</span>
              <span>Obtain transcripts and other follow-up matters</span>
            </div>
          </div>
        </div>
      </section>
      <section class="con4">
        <div class="main-center container">
          <h2>We Are Here to Help</h2>
          <!--<span>We hope that with the support of LightCourse, every student will find the process of transferring credits to be simple and convenient.</span>-->
          <p class="f-medium" style="white-space: inherit;margin-top: 20px;">
            Our team of LightCourse advisors is readily available to assist you at every stage of the process. We aspire that, with LightCourse's support, <br>all students will experience a convenient and efficient journey.
          </p>
          <div class="shadow">
            <p>
              Speak to a LightCourse advisor<br />
              to consult with your questions or problems regarding the registration progress.
            </p>
            <div class="more-btn">
              <a href="javascript:;" @click="openTalkAdvise" class="form-clk">Schedule an appointment <em class="f-regular">></em></a>
            </div>
          </div>
        </div>
      </section>
    </main>
    <Contact ref="contactDialog"></Contact>
  </div>
</template>
<script>
import Swiper from "swiper";
import Contact from "../../components/Contact/Contact";
import "../../assets/js/swiper.animate.min.js"
  export default {
    data() {
      return {

      }
    },
    computed: {

    },
    components: {
      Contact
    },
    methods:{
      openTalkAdvise() {
        this.$refs.contactDialog.openTalkAdvise();
      },
      initSwiper() {
        new Swiper('.student-programs-swiper .swiper-container',{
          loop:true,//开启循环播放
          autoplay: true, //自动播放
          effect : 'slide',//轮播的动效 默认为"slide"（普通位移切换），还可设置为"fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）、"cards"(卡片式)、"creative"（创意性）。
          pagination: {
            el: '.student-programs-swiper .swiper-pagination',
            clickable :true,
          },
          on:{
            init: function(){
              //swiperAnimateCache(this); // 隐藏动画元素
              //swiperAnimate(this); // 初始化完成开始动画
            },
            slideChangeTransitionEnd: function(){
              //swiperAnimate(this); // 每个slide切换结束时也运行当前slide动画
              // this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
            },
          }
        });
      }
    },
    created() {

    },
    mounted() {
      this.initSwiper();
      this.$nextTick(() => {
        new this.$wow.WOW().init();
      });
    },
    watch: {

    }
  }
</script>

<style scoped src="../../assets/css/see.css"></style>
<style scoped>
  @media screen and (max-width: 1600px) {
  .form-container {
      max-height: 18rem;
      overflow-x: hidden;
      margin-top: 20px;
    }
  }
  .m-box {
    margin-top: 20px;
  }
  .m-item h5 {
    text-align: left;
    font-size: 22px !important;
  }
  .m-box .line {
    margin: 0 10px;
    display: block;
    width: 1px;
    height: 200px;
    background: #3b52f6;
  }
  .see-container .shadow{
    width: 79%;
    border: 1px solid #5b5b5b;
    border-radius: 1rem;
    margin: 3rem auto 0;
    padding: 1rem;
    text-align: center;
  }

  .see-container .shadow p{
    font-size: 1rem;
    line-height: 1.4;
  }
  .see-container.shadow span{
    display: block;
    color: #3456fd;
  }

  .see-container .shadow .more-btn{
    display: flex;
    justify-content: center;
    max-width: 70rem;
    height: 1rem;
    margin: 1rem auto 0;
  }
  .see-container .shadow .more-btn>a{
    border: 0;
    color: #838383;
    font-size: 0.85rem;
    padding: 0 1rem 0 0;
    text-align: left;
    transition: all .6s;
    position: relative;
  }
  .see-container .shadow .more-btn>a em{
    display: inline-block;
    margin-left: 0.4rem;
    position: absolute;
    top: 50%;
    right: 0;
    transform: scaleY(1.8) translateY(-30.5%);
    transition: all .6s;
  }
  .see-container .shadow .more-btn>a:hover{
    background: none;
    color: #00db6d !important;
  }
  .see-container .shadow .more-btn>a:hover em{
    right: -0.3rem;
    color: #00db6d;
  }
  .see-container .con4 .main-center{
    max-width: 82.08%;
    background-color: #dedede;
    border-radius: 0.75rem;
    padding: 3.1rem 10%;
    text-align: center;
  }

  .see-container .con4 h2{
    font-size: 1.9rem;
    line-height: 1.2;
    color: #3456fd;
  }
  .see-container .con4 span{
    display: block;
    font-size: 0.85rem;
    line-height: 1.4;
    margin: 1.5rem 0 1.2rem;
    color: #3456fd;
  }
  .see-container .con4 p{
    font-size: 0.85rem;
    line-height: 1.4;
    margin-bottom: 0 !important;
    color: #505050;
  }

  .see-container .con4 .shadow{
    margin-top: 2.5rem;
    background-color: #3456fd;
    width: 100%;
  }
  .see-container .con4 .shadow p{
    color: #ffffff;
  }
  .see-container .con4 .shadow .more-btn a{
    color: #00db6d;
  }


  .see-container .con4 .bor {
    border-radius: 0.25rem;
    padding: 2rem;
    font-size: 1.3rem;
    font-weight: bold;
    max-width: 66rem;
    margin: 2rem auto;
    background-image: url(https://siteh5.lightcourse.com/pc/home/new/images/4623.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .see-container .con4 .bor p {
    margin-top: 0;
    font-size: 0.9rem;
  }
  @media screen and (max-width: 900px) {
    .main-4 .main-center {
      max-width: 100%;
    }
    .main-4 .participate-list .item>span {
      font-size: 12px;
    }
    .main-4 .participate-list .item>span:last-child {
      text-indent: 0;
      padding-left: 5px;
    }
    .student-programs-swiper .swiper-slide {
      height: 10rem;
    }
    .student-programs-swiper .swiper-slide img {
      min-height: 0;
    }
    .see-container .main-1-1 .main-center {
      max-width: 100%;
    }
    .see-container .main-1-1 .title {
      padding: 1rem 1.5rem;
    }
    .see-container .t h2 {
      font-size: 1.5rem;
    }
    .see-container .main-1-1 .item {
      width: 100%;
      margin-bottom: 5px;
    }
    .see-container .main-1-1 .list {
      flex-direction: column;
    }
    .see-container .main-1-1 .list-last .item:first-child {
      width: 100%;
      padding-left: 2rem;
    }
    .see-container .con4 .main-center {
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Document/Document.vue